import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import classNames from 'classnames';
import * as styles from './Link.css';
import { useDeviceType } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export function Link(_ref) {
  var href = _ref.href,
    children = _ref.children,
    target = _ref.target,
    onClick = _ref.onClick,
    title = _ref.title,
    disabled = _ref.disabled,
    dataMark = _ref.dataMark,
    responsive = _ref.responsive;
  var linkRel = target === '_blank' ? 'noreferrer' : undefined;
  var deviceType = useDeviceType();
  var handleClick = React.useCallback(function (e) {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (!onClick) {
      return;
    }
    onClick(e);
  }, [onClick, disabled]);
  return /*#__PURE__*/_jsx("a", {
    href: href,
    className: classNames(styles['link'], _defineProperty(_defineProperty({}, styles['link-disabled'], disabled), styles["link--".concat(deviceType)], responsive)),
    target: target,
    title: title,
    rel: linkRel,
    onClick: handleClick,
    "data-mark": dataMark || 'Link',
    children: children
  });
}